import { getSharedConfig } from "../../createSharedConfig"
import { RACK_COLORS } from "@/js/pages/product/rackbuilder/constants"
import { RackOptions } from "@/js/pages/product/rackbuilder/RackTypes"
import { findBundleProduct, getAccessoryQuantity } from "@/js/pages/product/rackbuilder/utils/product-lookup"
import { getCommonAccessorySelections } from "@/js/pages/product/rackbuilder/utils/selection-utils"
import { IRogue, BuyRequest } from "@/js/services/RogueTypes"
import { getSimpleForBuyRequest } from "@/js/helpers/buy-request"

export function createTwinHRAddonConfig(rogue: IRogue, buyRequest: BuyRequest): RackOptions {
  const ft = getSimpleForBuyRequest(buyRequest, rogue)
  const functionalTrainer = findBundleProduct(rogue, buyRequest, 'trainer')

  const sharedConfig = getSharedConfig(rogue, buyRequest)
  const height = (ft?.attributes.rack_height as string)?.replace('"', '') as RackOptions['height'] || '100'
  const { trolleySelection, lowRowSelection, latBarSelection } = getCommonAccessorySelections(rogue, buyRequest, sharedConfig.materials || {})

  return {
    ...sharedConfig,
    back            : '',
    front           : 'crossmember top 4',
    edition         : 'twin',
    color           : RACK_COLORS['Rogue Red'],
    jcup            : '',
    height,
    depth           : '2',
    sixPost         : false,
    storagePosts    : false,
    ghostRack       : false,
    ftShrouds       : functionalTrainer?.attributes?.rig_or_wm === 'Yes',
    spotterArms     : getAccessoryQuantity(rogue, buyRequest, 'safety spotter'),
    frontStabilizer : Boolean(findBundleProduct(rogue, buyRequest, 'half rack feet', true)),
    trolleySelection,
    latBarSelection,
    lowRowSelection,
    isAddon         : true,
  }
}
